import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const NEEDS = ['Técnica', 'Reflejos', 'Lectura táctica', 'Posicionamiento', 'Juego con los pies', 'Control emocional', 'Mentalidad competitiva'];
export const ProblemAndWhatIs = () => {
  return <section className="py-10 md:py-16 px-4 bg-forest-900/40" data-id="element-71">
      <div className="max-w-2xl mx-auto" data-id="element-72">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-forest-900 border border-forest-800 rounded-2xl p-6 md:p-8 shadow-xl" data-id="element-73">
          <h2 className="font-anton text-2xl md:text-4xl text-white uppercase tracking-wide text-center mb-3" data-id="element-74">
            EL PROBLEMA <span className="text-red-500" data-id="element-75">NO ES TU TALENTO</span>
          </h2>

          <p className="text-sm md:text-base text-forest-300 text-center mb-6" data-id="element-76">
            El verdadero problema es entrenar sin un sistema. Hoy un arquero
            necesita:
          </p>

          <div className="grid grid-cols-2 gap-x-3 gap-y-2.5 mb-6 max-w-md mx-auto" data-id="element-77">
            {NEEDS.map((item, i) => <div key={i} className="flex items-center gap-2 text-sm md:text-base text-forest-100 font-medium" data-id="element-78">
                <div className="bg-grass-400/15 p-1 rounded-full shrink-0" data-id="element-79">
                  <Check size={12} className="text-grass-400" strokeWidth={3} data-id="element-80" />
                </div>
                <span data-id="element-81">{item}</span>
              </div>)}
          </div>

          <p className="text-grass-400 font-anton text-base md:text-xl tracking-wide uppercase text-center border-t border-forest-800 pt-4" data-id="element-82">
            Y ahí es donde entra Arquero PRO System
          </p>
        </motion.div>
      </div>
    </section>;
};